export * from './PageHeader.js'
export * from './AppSidebar.js'
export * from './AppSidebarLink.js'
export * from './SharedPersonCard.js'
export * from './OnlineUsersBar.js'
export * from './IconSection.js'
export * from './StoryCard.js'
export * from './StoriesSection.js'
export * from './SharedViewSwitcher.js'
export * from './PageHero.js'
// AppAssistant + ComposerBox live in workspace/packages/shared/components and
// auto-register through sharedLibraries — no re-export needed.
export * from './AppWorkspaceSwitcher.js'
export * from './UpgradeBanner.js'
export * from './NoOrgOverlay.js'
// ChatDrawer + Notifications live in workspace/packages/shared/components
// and auto-register through sharedLibraries — no re-export needed.
export * from './AppLightbox.js'
export * from './SidebarItemMore.js'
export * from './SidebarRow.js'
export * from './ConfirmModal.js'
export * from './CapTableGrantModal.js'
export * from './LinkedResources.js'
// IntegrationScopePicker + IntegrationScopeBadge + resolveScope now live
// in workspace/packages/shared and are picked up via sharedLibraries.js.
export * from './NotificationBell.js'
export * from './NavSearchDropdown.js'

// ── Intranet core ──
export * from './IntranetAppHeader.js'
export * from './ContentPage.js'
export * from './PersonCard.js'
export * from './IntranetRows.js'
export * from './WysiwygToolbar.js'

// ── Member profile ──
export * from './MemberProfile.js'
export * from './ProfileAvailabilityGrid.js'

// ── Admin (pages moved to shared/pages/admin/ — Phase 6) ──
// Re-exported here so workspace-project's component registry stays intact.
export { AdminSidebar, AdminSidebarLink, AdminUserRow } from '../../shared/pages/admin/admin.js'
export { AdminActivityScoringRow } from '../../shared/pages/admin/activity-scoring.js'
export { AdminLogDay, AdminLogGroup, AdminLogRow, AdminLogCalendar, AdminLogCalendarCell } from '../../shared/pages/admin/logs.js'
export { IntegrationCategoryGroup, IntegrationCategoryCard } from '../../shared/pages/admin/integrations.js'
export {
  SupabaseNewForm, SupabaseFormField, SupabaseInstanceList, SupabaseInstanceCard
} from '../../shared/pages/admin/integrations-supabase.js'
export {
  GithubNewForm, GithubField, GithubInstanceList, GithubInstanceCard
} from '../../shared/pages/admin/integrations-github.js'
export {
  GoogleConfigCard, GoogleField
} from '../../shared/pages/admin/integrations-google.js'
export {
  NpmNewForm, NpmField, NpmInstanceList, NpmInstanceCard
} from '../../shared/pages/admin/integrations-npm.js'
// GenericIntNewForm + GenericIntConfigField + GenericIntInstanceCard
// moved to workspace/packages/shared/components/IntegrationConfigureForm.js
// — picked up via sharedLibraries.js.
export { AdminStatusSection, AdminStatusRow } from '../../shared/pages/admin/status.js'
export { McpConnectorAdminCard, AdminMcpConnectors } from '../../shared/pages/admin/integrations-mcp.js'

// ── Data (governance/projects/users browser) ──
export { DataSidebarLink, DataUserRow, DataProjectRow, DataSubscriptionRow, DataPlanFeature, DataPlanFeatureRow } from '../pages/data.js'

// ── Merged governance apps — component names are already prefixed
// (Cal*, Tickets*, Chat*, Docs*, Meet*) so there are no conflicts. ──
export * from './calendar/index.js'
export * from './tickets/index.js'
export * from './documents/index.js'
export * from './meet/index.js'
